// extracted by mini-css-extract-plugin
export default {"paymentSection":"K5-z","disabled":"L5-z"};